import {
  readIgnoreTextWrapFromPageElementBase,
  readIsFrozenFromPageElementBase,
  readIsLockedFromPageElementBase,
} from '@/lib/elements/read-page-element-base-flags'
import type { DocumentProjection } from '@/lib/canvas/types/document-projection'
import { readPageElementEditorRectFromBase } from '@/lib/elements/read-page-element-editor-rect'
import { type AnyRecord, asRecord, finiteNumber } from './tolerant-read'

export function getBaseGeometry(
  decodedData: AnyRecord,
  projection: DocumentProjection
): {
  x: number
  y: number
  width: number
  height: number
  rotation: number
  locked: boolean
  frozen: boolean
  ignoreTextWrap: boolean
  transparency: number
  uid: number | undefined
} | null {
  const base = asRecord(decodedData.base) ?? asRecord(decodedData.Base)

  if (!base) return null

  const baseRecord = base as Record<string, unknown>
  const rect = readPageElementEditorRectFromBase(baseRecord, projection)

  if (!rect) return null

  const { x, y, width, height } = rect

  const rotation = finiteNumber(base.rotation ?? base.Rotation) ?? 0
  const locked = readIsLockedFromPageElementBase(baseRecord)
  const frozen = readIsFrozenFromPageElementBase(baseRecord)
  const ignoreTextWrap = readIgnoreTextWrapFromPageElementBase(baseRecord)
  const transparencyRaw = finiteNumber(base.transparency ?? base.Transparency) ?? 0
  const transparency = Math.max(0, Math.min(100, Math.round(transparencyRaw)))
  // uid 0 means "unset" on the wire, so it must not become a real chain key (WMPCM-7988).
  const uidRaw = finiteNumber(base.uid ?? base.Uid)
  const uid = uidRaw !== null && uidRaw > 0 ? uidRaw : undefined

  return { x, y, width, height, rotation, locked, frozen, ignoreTextWrap, transparency, uid }
}
